import { Stack } from 'expo-router';
import React from 'react';

function RewardsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="[id]"
        options={{
          presentation: 'transparentModal',
          animation: 'fade_from_bottom',
        }}
      />
      <Stack.Screen
        name="upside-offers/[merchantId]"
        options={{
          presentation: 'transparentModal',
          animation: 'fade_from_bottom',
        }}
      />
    </Stack>
  );
}

export default RewardsLayout;
